import ApiGateway from '../gateways/Api.gateway';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export const chatService = {
  async sendMessage(message: string): Promise<string> {
    try {
      const { response } = await ApiGateway.sendChatMessage(message);
      return response;
    } catch (error) {
      console.error('Error sending chat message:', error);
      throw error;
    }
  }
}; 
